
import boxNow from '~/components/core/boxNow.vue';
import cartMixins from "~/plugins/cartMixins";

export default {
  components: { boxNow },
  mixins: [cartMixins],
  async mounted() {},
};
